import logo from './logo.png';
import './loading.css';

function Loading() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h3>DATABOT</h3>
      </header>
    </div>
  );
}

export default Loading;
